export default "__VITE_ASSET__81c40e6b__"